import React from "react";
import PropTypes from "prop-types";
import loadable from "@loadable/component";
import * as dayjs from "dayjs";
import { addDays } from "date-fns";

import { AppContext } from "../../../context";
import { BRANDS, MODES } from "../../../configs";

const BrandDatePicker = loadable(() => import("./BrandDatePicker"));
const BrandDateRangePicker = loadable(() => import("./BrandDateRangePicker"));

const SovBrandDatePicker = loadable(() => import("./SovBrandDatePicker"));
const SovBrandDateRangePicker = loadable(() => import("./SovBrandDateRangePicker"));

const DatesField = ({
	id,
	type,
	mode,
	className,

	error,
	isWidgetReset,
	isOnlyDateField,
	openCalendar,
	isMultipleFlight,
	ishomePageTabletWidget,

	classnames,

	selectedDates,
	availableDates,
	previousDates,
	
	ParentRefElement,

	onChange,
	setShowPassengerPopover,
	setIsInitialSovMobileInputState,
	handleSovMobileInputSelectionToView,
}) => {
	const [useAppState] = AppContext.useAppContext();

	if (useAppState.brand === BRANDS.SOV) {
		// ******* SOV SINGLE CALENDAR ********************************
		if (type === "date") {
			return (
				<SovBrandDatePicker
					id={id}
					mode={mode}
					type={type}
					className={className}
					classnames={classnames}
					error={error}
					isWidgetReset={isWidgetReset}
					isOnlyDateField={isOnlyDateField}
					isMultipleFlight={isMultipleFlight}
					openMobileCalendar={openCalendar}
					defaultDate={selectedDates?.[0]}
					availableDates={availableDates}
					previousDates={previousDates}
					ParentRefElement={ParentRefElement}
					onChange={(startDate, returnDate) => {
						if(!returnDate){
							const newReturnDate = addDays(startDate, 7);
							onChange([dayjs(startDate), dayjs(newReturnDate)]);
						} else {
							onChange([dayjs(startDate), dayjs(returnDate)]);
						}
					}}
					setIsInitialSovMobileInputState={setIsInitialSovMobileInputState}
					setShowPassengerPopover={setShowPassengerPopover}
					handleSovMobileInputSelectionToView={handleSovMobileInputSelectionToView}
				/>
			);
		}

		// ******* SOV RANGE CALENDAR ********************************
		return (
			<SovBrandDateRangePicker
				id={id}
				mode={mode}
				type={type}
				className={className}
				error={error}
				isWidgetReset={isWidgetReset}
				isOnlyDateField={isOnlyDateField}
				ishomePageTabletWidget={ishomePageTabletWidget}
				openMobileCalendar={openCalendar}
				classnames={classnames}
				selectedDates={selectedDates}
				availableDates={availableDates}
				previousDates={previousDates}
				ParentRefElement={ParentRefElement}
				onChange={(startDate, returnDate) => {
					onChange([dayjs(startDate), dayjs(returnDate)]);
				}}
				setShowPassengerPopover={setShowPassengerPopover}
				setIsInitialSovMobileInputState={setIsInitialSovMobileInputState}
				handleSovMobileInputSelectionToView={handleSovMobileInputSelectionToView}
			/>
		);
	}

	// ******* SWG, VWQ SINGLE CALENDAR ********************************
	if (type === "date") {
		return (
			<BrandDatePicker
				className={className}
				id={id}
				defaultDate={selectedDates?.[0]}
				availableDates={availableDates}
				previousDates={previousDates}
				error={error}
				onChange={(startDate, returnDate) => {
					onChange([dayjs(startDate), dayjs(returnDate)]);
				}}
			/>
		);
	}

	// ******* SWG, VWQ RANGE CALENDAR ********************************
	return (
		<BrandDateRangePicker
			className={className}
			id={id}
			selectedDates={selectedDates}
			availableDates={availableDates}
			previousDates={previousDates}
			error={error}
			onChange={(startDate, returnDate) => {
				onChange([dayjs(startDate), dayjs(returnDate)]);
			}}
		/>
	);
};

DatesField.propTypes = {
	id: PropTypes.string.isRequired,
	mode: PropTypes.string,
	className: PropTypes.string,
	type: PropTypes.oneOf(["range", "date"]),

	error: PropTypes.bool,
	isWidgetReset: PropTypes.bool,
	isOnlyDateField: PropTypes.bool,
	isMultipleFlight: PropTypes.bool,
	ishomePageTabletWidget: PropTypes.bool,
	openCalendar: PropTypes.bool,


	classnames: PropTypes.shape({
		listboxTail: PropTypes.string,
	}),
	selectedDates: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.instanceOf(dayjs)),
		PropTypes.arrayOf(PropTypes.string),
		PropTypes.instanceOf(dayjs),
		PropTypes.string,
	]),
	availableDates: PropTypes.shape({
		RolloverAvailableDays: PropTypes.number,
		RolloverMaxAvailableDays: PropTypes.number,
		DefaultAvailableDate: PropTypes.string,
		DefaultMaxAvailableDate: PropTypes.string,
	}),
	previousDates: PropTypes.arrayOf(PropTypes.string),

	ParentRefElement:  PropTypes.shape({ current: PropTypes.node }),

	onChange: PropTypes.func.isRequired,
	setShowPassengerPopover: PropTypes.func,
	setIsInitialSovMobileInputState: PropTypes.func,
	handleSovMobileInputSelectionToView: PropTypes.func,
};

DatesField.defaultProps = {
	type: "range",
	mode: MODES.SEARCH,
	className: undefined,

	error: false,
	isWidgetReset: false,
	isOnlyDateField: false,
	isMultipleFlight: false,
	ishomePageTabletWidget: false,
	openCalendar: false,

	classnames: undefined,

	selectedDates: undefined,
	availableDates: undefined,
	previousDates: undefined,

	ParentRefElement: null,

	setShowPassengerPopover: () => {},
	setIsInitialSovMobileInputState: () => {},
	handleSovMobileInputSelectionToView: () => {},
};

export default DatesField;
export { DatesField };
